import { Refresh } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import { TooltipSquareIconButton } from 'components/common/icon/tooltip-icon-button';

export const RefreshOrLoading = ({
  onClick,
  refreshing,
  tooltip,
}: {
  onClick: () => Promise<any> | void;
  refreshing: boolean;
  tooltip: string;
}) => {
  return refreshing ? (
    <CircularProgress size={36} />
  ) : (
    <TooltipSquareIconButton onClick={onClick} tooltip={tooltip}>
      <Refresh />
    </TooltipSquareIconButton>
  );
};
